import Tmdb from "../../services/tmdb";

const tmdb = new Tmdb();

export const FETCH_UPCOMING_REQUESTED = "FETCH_UPCOMING_REQUESTED";
export const UPCOMING_LOADED = "UPCOMING_LOADED";
export const UPCOMING_ERROR = "UPCOMING_LOADED";
export const LOAD_MORE_REQUESTED = "LOAD_MORE_REQUESTED";
export const LOAD_MORE = "LOAD_MORE";

export const upcomingRequested = () => {
  return {
    type: FETCH_UPCOMING_REQUESTED
  };
};

export const upcomingLoaded = movies => {
  return {
    type: UPCOMING_LOADED,
    payload: movies
  };
};

export const upcomingMoreLoaded = movies => {
  return {
    type: LOAD_MORE,
    payload: movies
  };
};

export const moreLoadRequested = () => {
  return {
    type: LOAD_MORE_REQUESTED
  };
};

export const upcomingError = () => {
  return {
    type: UPCOMING_ERROR
  };
};

export const loadMore = page => {
  return dispatch => {
    dispatch(moreLoadRequested());
    tmdb
      .getUpcomingMovies(page)
      .then(data => dispatch(upcomingMoreLoaded(data)))
      .catch(() => dispatch(upcomingError()));
  };
};

export const fetchUpcomingMovies = page => {
  return dispatch => {
    dispatch(upcomingRequested());
    tmdb
      .getUpcomingMovies(page)
      .then(data => dispatch(upcomingLoaded(data)))
      .catch(() => dispatch(upcomingError()));
  };
};
